import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppShellComponent } from './modules/core/components/app-shell/app-shell.component';
import { AuthGuard, SIGNED_OUT_ROUTE, iconSet } from '@assets/shared'
import { SignedOutComponent } from './modules/core/components/signed-out/signed-out.component';

const routes: Routes = [{
  // The one route outside the AuthGuard. Everything else needs a session, so returning anywhere but
  // here after signing out would immediately start a new sign-in. Registered in Cardinal as this
  // application's post logout redirect uri; the path comes from SIGNED_OUT_ROUTE so the two cannot
  // drift apart. Listed first because it has to match before the shell's empty prefix does.
  path: SIGNED_OUT_ROUTE.substring(1),
  component: SignedOutComponent
}, {
  path: '',
  canActivate: [AuthGuard],
  component: AppShellComponent,
  children: [{
    path: 'dashboards',
    loadChildren: () => import('@assets/dashboards').then(m => m.AssetsDashboardsModule)
  }, {
    path: 'assets',
    loadChildren: () => import('@assets/assets').then(m => m.AssetsAssetsModule)
  }, {
    path: 'real-estates',
    loadChildren: () => import('@assets/real-estates').then(m => m.AssetsRealEstatesModule)
  }]
},
// {
//   path: '403',
//   component: ForbiddenComponent
// },
{
  path: '**',
  redirectTo: 'dashboards',
  pathMatch: 'full'
}];

export const mainNavigationRoutes: Routes = [{
  path: 'dashboards',
  data: {
    titleKey: 'Dashboards',
    isMainNavigation: true,
    icon: iconSet.chartSimpleSolid,
  }
}, {
  path: 'assets',
  data: {
    titleKey: 'Assets',
    isMainNavigation: true,
    icon: iconSet.listSolid,
  }
}, {
  path: 'real-estates',
  data: {
    titleKey: 'RealEstates',
    isMainNavigation: true,
    icon: iconSet.chartLine,
  }
}];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    paramsInheritanceStrategy: 'always'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
